export const GRID_AREAS = {
  HEADER: 'header',
  MAIN: 'main',
  MOBILE_BOTTOM_BAR: 'mobile-bar',
}
